import React from 'react';
import { CSSTransition } from 'react-transition-group';
import './transitions.scss';

export const Expand = ({ children, ...props }) => (
    <CSSTransition {...props} timeout={300} classNames="expand">
        {children}
    </CSSTransition>
);

export const EnterFrom = ({ children, from, ...props }) => (
    <CSSTransition
        {...props}
        unmountOnExit
        timeout={300}
        classNames={`from-${from}`}>
        {children}
    </CSSTransition>
);

export const EnterFade = ({ children, ...props }) => (
    <CSSTransition {...props} unmountOnExit timeout={400} classNames="fade">
        {children}
    </CSSTransition>
);
